<template>
  <div class="footer-box">
    <div class="footer-link">
      <div class="logo">
        <img src="../../assets/img/footer/logo-white.png">
      </div>
      <div class="link">
        <ul>
          <li><span class="link-title" @click="jumpTo('/')">平台</span></li>
          <li><span class="link-title" @click="jumpTo('/CasePage')">案例</span></li>
          <li><span class="link-title" @click="jumpTo('/DocumentPage')">文档</span></li>
          <li><span class="link-title" @click="jumpTo('/FrontierPage')">前沿</span></li>
          <li><span class="link-title" @click="jumpTo('/MallPage')">商城</span></li>
          <li><span class="link-title" @click="toLink">关于</span></li>
          <li>
            <span class="link-title">联系我们</span>
            <ul class="link-contact-info">
              <li>服务热线：</li>
              <li>400-600-7966</li>
              <li>公司地址：</li>
              <li>济南市高新区奥盛大厦2号楼</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="code">
        <img src="../../assets/img/footer/code.png"><br />
        关注微信公众号
      </div>
    </div>
    <div class="footer-copyright">
      <span>&copy; 2016-{{ currentYear }} 金现代信息产业股份有限公司</span>
      <span style="margin: 0 25px;">鲁ICP备09033671</span>
      <span><img src="../../assets/img/footer/beian.png" style="position: relative;top: 3px;margin-right: 6px">鲁公网安备 37010102000748号</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: '2022',
    };
  },
  methods: {
    // 跳转页面
    jumpTo(page) {
      const self = this;
      self.$router.push({ path: page });
    },
    // 打开公司官网
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
  },
  created() {
    const self = this;
		//获取当前年
		self.currentYear = new Date().getFullYear();
  },
};
</script>
<style scoped>
.footer-box {width: 100%;height: 263px;background: #2E2E2E;}
/* 友情链接 */
.footer-link {position: relative;width: 1200px;height: 224px;margin: 0 auto;}
/* logo */
.logo {width: 119px;float: left;padding-top: 36px;}
/* 链接 */
.link {float: left;width: 826px;margin-left: 104px;margin-right: 50px;padding-top: 40px;}
.link > ul > li {float: left;margin-right: 76px;}
.link > ul > li:last-child {margin-right: 0;}
.link-title {display: block;margin-bottom: 10px;color: #FFF;font-size: 16px;line-height: 22px;cursor: pointer;}
.link-contact-info {color: #BDBDBD;font-size: 14px;line-height: 28px;}
/* 二维码 */
.code {float: left;width: 100px;padding-top: 45px;color: #BDBDBD;font-size: 14px;line-height: 20px;text-align: center;}
.code img {margin-bottom: 6px;}
/* 版权信息 */
.footer-copyright {border-top: 1px solid rgba(255, 255, 255, 0.1);color: #67707D;line-height: 38px;font-size: 14px;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/include/Footer.vue